import * as React from 'react'
import { FC } from 'react'

import { Embed } from './Embed'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetEmbedUrlOnMount } from '../hooks/useGetEmbedUrlOnMount'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  locationId: string
  nameOnCard: string
  onClose: () => void
}

export const EmbedWrapper: FC<Props> = (props: Props) => {
  const { entityId, entityType, locationId, nameOnCard, onClose } = props
  const [status, url] = useGetEmbedUrlOnMount({
    locationId,
    nameOnCard,
  })

  return (
    <>
      {status == 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {status == 'success' && (
        <Box height={340}>
          <Embed
            entityId={entityId}
            entityType={entityType}
            onClose={onClose}
            url={url}
          />
        </Box>
      )}

      {status == 'fail' && (
        <Alert severity="error">
          Unable to add a payment at this time, please try again later.
        </Alert>
      )}
    </>
  )
}

EmbedWrapper.displayName = 'EmbedWrapper'
